// extracted by mini-css-extract-plugin
export default {"MainContainer":"Layout_MainContainer__PITPT"};